/** Company UI packs — Classic (current) | Simple (new touch UI). */

export const UI_PACK_CLASSIC = "classic";
export const UI_PACK_SIMPLE = "simple";

export const UI_PACK_OPTIONS = [
  { value: UI_PACK_CLASSIC, label: "Classic", hint: "Current ERP look (default)" },
  { value: UI_PACK_SIMPLE, label: "Simple (touch)", hint: "Multi-color, large buttons — full redesign" },
];

export function normalizeUiPack(value) {
  const v = String(value || "").trim().toLowerCase();
  return v === UI_PACK_SIMPLE ? UI_PACK_SIMPLE : UI_PACK_CLASSIC;
}

export function uiPackLabel(value) {
  return normalizeUiPack(value) === UI_PACK_SIMPLE ? "Simple (touch)" : "Classic";
}

export function isSimpleUiPack(value) {
  return normalizeUiPack(value) === UI_PACK_SIMPLE;
}
